import { textRichUtils } from '@nextiva/rich-text-editor/';
// Using textRichUtils to create @draft-js Content state from plain text if option doesn't have it @sinslav
export default option =>
  option.content || textRichUtils.convertStringToRawContent(option.value);
